export const SERVICES_TYPES = {
  ApiClient: Symbol.for('ApiClient'),
  SiteType: Symbol.for('SiteService'),
  LocalControllerService: Symbol.for('LocalControllerService'),
  ChargerService: Symbol.for('ChargerService'),
  PermissionChecker: Symbol.for('PermissionChecker'),
  LocalControllerRealTimeEvent: Symbol.for('LocalControllerRealTimeEventService'),
  ChargerRealTimeEvent: Symbol.for('ChargerRealTimeEventService'),
  ConnectorRealTimeEvent: Symbol.for('ConnectorRealTimeEventService'),
  KpiService: Symbol.for('KpiService'),
  FilteringHelper: Symbol.for('FilteringHelper'),
  ActionLogService: Symbol.for('ActionLogService'),
  CaseManagementService: Symbol.for('CaseManagementService'),
  SessionService: Symbol.for('SessionService'),
  AuthorisationService: Symbol.for('AuthorisationService'),
  WorkOrderService: Symbol.for('WorkOderService'),
  UserManagementService: Symbol.for('UserManagementService'),
  DiagnosticService: Symbol.for('DiagnosticService'),
  CommandRealTimeEvent: Symbol.for('CommandRealTimeEventService'),
  SessionRealTimeEvent: Symbol.for('SessionRealTimeEventService'),
  FirmwareService: Symbol.for('FirmwareService'),
  ManufacturerSerice: Symbol.for('ManufacturerService'),
  PowerBIService: Symbol.for('PowerBIService'),
  LoyaltyService: Symbol.for('LoyaltyService')
}
